import React from "react";
import "../styles/About.css";
import { useLanguage } from "../contexts/LanguageContext";

const About = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const a = text.about;

  return (
    <section id="about" className="about-section" dir={isHeb ? "rtl" : "ltr"}>
      <div className="about-grid">
        <div className="about-photo" aria-hidden="true">
          <div className="about-photo-frame">
            <span className="about-initials">{a.initials}</span>
            <div className="about-photo-glow" />
          </div>
        </div>

        <div className="about-copy">
          <span className="eyebrow">{a.eyebrow}</span>
          <h2 className="about-title">{a.title}</h2>
          <p className="about-lede">{a.lede}</p>

          <ul className="about-points">
            {a.points.map((point) => (
              <li key={point}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                  <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>{point}</span>
              </li>
            ))}
          </ul>

          <a className="btn btn-primary about-cta" href="#contact">
            {a.cta}
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
